import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-youtube",
  "use": "icon-youtube-usage",
  "viewBox": "0 0 32 22.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 22.5\" id=\"icon-youtube\"><path d=\"M31.68,4.86A6.92,6.92,0,0,0,30.4,1.68,4.58,4.58,0,0,0,27.2.32C22.72,0,16,0,16,0h0S9.28,0,4.8.32A4.58,4.58,0,0,0,1.6,1.68,6.92,6.92,0,0,0,.32,4.86,48.4,48.4,0,0,0,0,10v2.46a48.4,48.4,0,0,0,.32,5.18A6.92,6.92,0,0,0,1.6,20.82a5.42,5.42,0,0,0,3.52,1.36c2.56.24,10.88.32,10.88.32s6.72,0,11.2-.34a4.58,4.58,0,0,0,3.2-1.36,6.92,6.92,0,0,0,1.28-3.18A48.46,48.46,0,0,0,32,12.46V10a48.46,48.46,0,0,0-.32-5.18M12.7,15.4v-9l8.64,4.52Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/youtube.svg
// module id = 316
// module chunks = 0 1